import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { Z_INDEX } from "~/styles/z-index";

export const DivOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(${COLOR.GRAY50.rgb}, 0.4);
  z-index: ${Z_INDEX.HEADER - 10};
`;

export const ArtProductHeaderWrap = styled.article`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
